import List from './List';

export default List;



// WEBPACK FOOTER //
// ./src/components/Building/Chess/List/index.js